export class TaskListOperation {
  public readonly id = `${this.taskListType}-${this.taskListGroup}-${this.groupCounter}-${this.nodes}`;

  public constructor(
    public groupCounter: string,
    public sequence: string,
    public taskListType: string,
    public taskListGroup: string,
    public nodes: string,
    public operationShortText: string
  ) {}
}
